module.exports = __webpack_public_path__ + "img/image00010-min.1ce0e350.jpeg";